import * as React from 'react'
import styled from 'styled-components'

import { withRouter, RouteComponentProps } from 'react-router'

const Selection = require('./selection.svg')

const NavLinkLi = styled.li`
  margin: 0 20px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;

  img {
    width: 45px;
    height: 35px;
    margin-bottom: 8px;
  }

  button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    color: inherit;
    border: 0;
    outline: 0;
    background: none;
    cursor: pointer;
    font-size: ${({ theme }) => theme.fonts.defaultSize};
    text-transform: uppercase;

    &:disabled {
      opacity: 0.3;
    }
  }

  &.active {
    background-image: url(${Selection});
    background-position: bottom center;
    background-repeat: no-repeat;
    background-size: 26px 13px;
    color: ${({ theme }) => theme.colors.brand};
  }
`

type Props = {
  to?: string
  disabled?: boolean
  onClick?: () => void
} & RouteComponentProps<void>

/* Specify either to or onClick. If onClick is specified, it will have
   priority. Otherwise #<to> will be pushed to location. */
const NavLink: React.SFC<Props> = props => {
  const { to, history, children, location, disabled, onClick } = props

  return (
    <NavLinkLi className={location.hash === `#${to}` ? 'active' : ''}>
      <button
        disabled={disabled}
        onClick={() => (onClick ? onClick() : history.push(`#${to}`))}
      >
        {children}
      </button>
    </NavLinkLi>
  )
}

export default withRouter(NavLink)



// WEBPACK FOOTER //
// ./src/Components/Layout/NavLink.tsx